import { render, staticRenderFns } from "./MatchProductPrincipalAccordion.vue?vue&type=template&id=f29c81f2&scoped=true&"
import script from "./MatchProductPrincipalAccordion.vue?vue&type=script&lang=ts&"
export * from "./MatchProductPrincipalAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MatchProductPrincipalAccordion.vue?vue&type=style&index=0&id=f29c81f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29c81f2",
  null
  
)

export default component.exports